<div *ngIf="notification?.isVisible" [ngClass]="['notifications', notificationPosition]">
  <div class="notification" [ngClass]="[notification?.type, notification?.hasIcon ? 'has-icon' : '']">
    <span class="notification-icon" *ngIf="notification?.hasIcon && notification?.iconUrl">
      <img [src]="notification?.iconUrl" alt="Notification Icon" />
    </span>
    <div class="notification-content">
      <span [innerHTML]="notification?.message"></span>
    </div>
    <div class="notification-button" *ngIf="notification?.closeButton">
      <span class="close-button" role="button" tabindex="0" (click)="closeNotification()"
        (keydown.enter)="closeNotification()" (keydown.space)="closeNotification()">×</span>
    </div>
  </div>
</div>
